export default __webpack_public_path__ + "images/e4f9417760a0a7f29217a2c2656cd5a6-gala.jpg";